export const removeHighlight = (field: string) => field.replace(/<\/?mark>/gi, '');
export const skillUrl = (skillCode: string) => `/skill/${removeHighlight(skillCode)}`;
